module.exports = __webpack_public_path__ + "static/dark-text-bg-small-a77c3e35744e038d17e0b1cef6aff2de.gif";